import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  link: {
    color: "#fff !important",
    textDecoration: "none !important",
  },
  container: {
    width: "260px",
    height: "18rem",
    display: "flex",
    padding: "1.25rem",
    overflow: "hidden",
    position: "relative",
    backgroundSize: "cover",
    flexDirection: "column",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.up('sm')]: {
      width: "240px",
    },
  },
  typeWrapper: {
    fontSize: 11,
    fontWeight: 500,
    textTransform: "uppercase",
  },
  typeText: {
    borderBottom: "1px solid #fff",
    paddingBottom: 4,
  },
  title: {
    maxWidth: "70%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    fontSize: 18,
    lineHeight: 1.2,
    fontWeight: 600,
    paddingBottom: "0.75rem",
  },
  learnMore: {
    fontSize: 13,
    fontWeight: 700,
  },
}));
